import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../ui';

interface IAccordionProps {
	children: ReactNode;
	className?: string;
}

const StyledAccordion = styled('div')<{}, ITheme>`
	border-top: none;
`;

export function Accordion({ children, className }: IAccordionProps) {
	return <StyledAccordion className={className}>{children}</StyledAccordion>;
}
